// extracted by mini-css-extract-plugin
export default {"buttons":"ValueButtons_buttons__g0Y7G"};